export function convertToFormData(data) {
  const formData = new FormData();
  formData.append('game', data.game);

  // Add file field (if a file exists)
  if (data.file && data.file.name) {
    formData.append('file', data.file);
  }

  // Add players dynamically
  data.players.forEach((player, index) => {
    formData.append(`players[${index}][name]`, player.name);
    formData.append(`players[${index}][enrollmentNumber]`, player.enrollmentNumber);
    formData.append(`players[${index}][tShirtSize]`, player.tShirtSize);
    formData.append(`players[${index}][semester]`, player.semester);
    formData.append(`players[${index}][phone]`, player.phone);
    formData.append(`players[${index}][role]`, player.role);
  });

  return formData;

  return formData;
}